import React from 'react'

const DuplicatedVideoIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M0.73327 1.92133e-07C0.32839 1.92133e-07 0 0.252618 0 0.564054V16.9231C0 17.2345 0.328403 17.4871 0.73327 17.4871H5.86649V21.4357L5.86674 21.4359C5.86674 21.7474 6.19489 22 6.60002 22H21.2667C21.6716 22 22 21.7474 22 21.4359V5.07693C22 4.76529 21.6716 4.51288 21.2667 4.51288H16.1335V0.564251L16.1333 0.564054C16.1333 0.252608 15.8051 0 15.4 0L0.73327 1.92133e-07ZM1.46654 1.12811H14.6666V16.3589H1.46654V1.12811ZM16.1333 5.64104H20.5332V20.8718H7.33316V17.4873H15.3999C15.805 17.4873 16.1331 17.2347 16.1331 16.9232L16.1333 5.64104Z" fill="black" />
        </svg>
    )
}

export default DuplicatedVideoIcon